<template>
  <vxe-grid
    ref="skuTable"
    auto-resize
    highlight-hover-row
    resizable
    show-footer
    size="mini"
    cell-class-name="align-top"
    :toolbar-config="tableToolbar"
    :data="tableData"
    :columns="tableColumns"
    :max-height="635"
    :loading="loading"
    :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
    :edit-rules="editRules"
    :footer-method="() => footerData"
    @edit-closed="editClosed"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
        >
          <i class="el-icon-delete tool-btn" @click="remove(row)"></i>
        </el-tooltip>
      </div>
    </template>
    <template v-slot:displayName="{ row }">
      <div class="m-0">
        <div>{{ row.goodsName }}</div>
        <div>{{ row.goodsNameEn }}</div>
        <div>
          <span>SIZE:</span><span>{{ row.goodsSize }}</span>
        </div>
        <div>
          <span>COLOR:</span
          ><span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
        </div>
      </div>
    </template>
    <template v-slot:displayNo="{ row }">
      <div class="m-0">
        <div>NC:{{ row.ncNo }}</div>
        <div>SKU:{{ row.amzSkuNo }}</div>
      </div>
    </template>
    <template v-slot:displayAmzNo="{ row }">
      <div class="m-0">
        <div>
          <span>{{ $l('form_label_StoreSkuNo') || '店铺SKU' }}:</span
          ><span style="color: #409EFF">{{ row.amzStoreSkuNo }}</span>
        </div>
        <div>
          <span>FNSKU:</span
          ><span style="color: #409EFF">{{ row.fnskuCode }}</span>
        </div>
        <div>
          <span>ASIN:</span>
          <span style="color: #409EFF">{{ row.asinCode }}</span>
        </div>
      </div>
    </template>
    <template v-slot:defaultImageUrl="{ row }">
      <el-image
        :src="
          row.defaultImageUrl
            ? $osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg'
        "
        :preview-src-list="[
          row.defaultImageUrl
            ? $osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg',
        ]"
        style="width:60px; "
      >
        <div slot="error" class="image-slot">
          <img src="/image/static/img/nopic.jpg" style="width: 60px;" />
        </div>
      </el-image>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
import { format, add, multiply, divideRound } from '@/libs/util.number.js'
export default {
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: this.disabled ? { query: () => this.$emit('reload') } : null,
        zoom: true,
        custom: true,
      },
      tableData: [],
      calcTableData: [],
      format: (number) => format(number),
      multiply: (x, y) => multiply(x, y),
      divideRound: (x, y, l = 4) => divideRound(x, y, l),
      tableColumns: tableColumns(this),
      editRules: {
        inCtnQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        amzBoxNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
      },
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.calcTableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[3] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    setData(data) {
      this.tableData = data
      this.calcTableData = data
    },
    async resetCalcTable() {
      this.calcTableData = await this.getTableData()
      this.$refs.skuTable.updateFooter()
    },
    async remove(row) {
      await this.$refs.skuTable.remove(row)
      this.resetCalcTable()
    },
    async insertAt(records, row = -1) {
      const result = await this.$refs.skuTable.insertAt(records, row)
      await this.resetCalcTable()
      return result
    },
    async editClosed({ row }) {
      const {
        inCtnQty,
        ctnQty,
        ctnLength,
        ctnWidth,
        ctnHeight,
        ctnGrossWeight,
        ftyPrice,
      } = row

      const goodsQty = multiply(inCtnQty, ctnQty)
      const subCbm = multiply(
        divideRound(
          multiply(multiply(ctnLength, ctnWidth), ctnHeight),
          1000000,
          2
        ),
        ctnQty
      )
      const subGrossWeight = multiply(ctnGrossWeight, ctnQty)
      const subAmount = multiply(ftyPrice, goodsQty)

      row.goodsQty = goodsQty
      row.subCbm = subCbm
      row.subGrossWeight = subGrossWeight
      row.subAmount = subAmount

      this.resetCalcTable()
    },
    async getTableData() {
      const { tableData } = await this.$refs.skuTable.getTableData()
      return tableData
    },
    async validate() {
      const tableData = await this.getTableData()
      if (!tableData || !tableData.length) {
        this.$message.error(this.$l('tips_pleaseAddSku') || '请添加产品明细！')
        return false
      }
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
